import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ReactFlow,
  Controls,
  Background,
  MiniMap,
  applyNodeChanges,
  applyEdgeChanges,
  useReactFlow ,
  ReactFlowProvider,

} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import {
  Select,
  MenuItem,
  Button,
  Typography,
  TextField,
  Box,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme,
  CircularProgress,
  ToggleButton, // Add this
  ToggleButtonGroup,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterListIcon from "@mui/icons-material/FilterList";
import * as Actions from "../dashboard/store/actions";
import { Checkbox, ListItemText } from "@mui/material";
import "./SprintDashboard.css";
import { max } from "moment";
import Menu from '@mui/material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { filterRecentByStatus } from "../../utils/SprintDashboard";

const SprintDashboard = () => {
  const dispatch = useDispatch();
  const [selectedSprint, setSelectedSprint] =useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [sideBarContent, setSideBarContent] = useState([]);
  const [allTicketsByEmployee, setallTicketsByEmployee] = useState([]);
  const [expandedTickets, setExpandedTickets] = useState({});
  const [selectedPriorities, setSelectedPriorities] = useState([]);
  const [selectedIssueType, setSelectedIssueType] = useState("");
  const [isLeftSidebarOpen, setIsLeftSidebarOpen] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState(["A"]);
  const [role, setRole] = useState("assignee");
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const searchMenuOpen = Boolean(searchAnchorEl);

  const allProjects = useSelector((state) => state.sprintReducer.projects);
  const [selectedProjectKey, setSelectedProjectKey] = useState("");
  const [projectBoardType, setProjectBoardType] = useState(null);
  const [recentFilter, setRecentFilter] = useState("");
  const [kanbanRecentFilter, setKanbanRecentFilter] = useState("");


  const ticketDetails = useSelector(
    (state) => state.sprintReducer.ticketDetails
  );
  const loadingTickets = useSelector(
    (state) => state.sprintReducer.loadingTickets
  );
  const isLoading = Object.values(loadingTickets).some((loading) => loading);

  const sprints = useSelector((state) => state.sprintReducer.sprints);
  const sprintTickets = useSelector(
    (state) => state.sprintReducer.sprintTickets
  );

  const kanbanTickets = useSelector(state => state.sprintReducer.kanbanTickets);

  const ticketsByDateRange = useSelector(
    (state) => state.sprintReducer.ticketsByDateRange
  );

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const statusColors = {
    "To Do": { background: "#d9edf7", color: "#31708f" },
    "In Progress": { background: "#fcf8e3", color: "#8a6d3b" },
    Done: { background: "#dff0d8", color: "#3c763d" },
    "In Review": { background: "#f2dede", color: "#a94442" },
    Blocked: { background: "#ffe5e5", color: "#d9534f" },
    Review: { background: "#e6f7ff", color: "#0056b3" },
    "Ready for review": { background: "#fdfde6", color: "#000" },
    default: { background: "#f9f9f9", color: "#333" },
  };

  useEffect(() => {
    setNodes((prevNodes) =>
      prevNodes.map((node) => ({
        ...node,
        style: {
          ...node.style,
          boxShadow: node.id === selectedNodeId ? "0 0 10px 6px rgb(248, 89, 57), 0 0 20px 5px rgba(0, 0, 0, 0.3)" : "none",
        },
      }))
    );
  }, [selectedNodeId]);

  useEffect(() => {
  if (projectBoardType === "kanban") {
    setSideBarContent(kanbanTickets);
    setallTicketsByEmployee(kanbanTickets);
  } else {
    setSideBarContent(sprintTickets);
    setallTicketsByEmployee(sprintTickets);
  }
}, [kanbanTickets, sprintTickets, projectBoardType]);


  useEffect(() => {
  const fetchBoardAndData = async () => {
    if (!selectedProjectKey) return;

    const board = await dispatch(Actions.getProjectBoardDetails(selectedProjectKey));
    setProjectBoardType(board?.type);
    const isRND = selectedProjectKey === "RD";

    if (board?.type === "scrum") {
      dispatch(Actions.getSprints(board.id));
    }

    if (board?.type === "kanban") {
      if (isRND && !startDate && !endDate) {
        const today = new Date().toISOString().split("T")[0];
        setStartDate("2025-01-01");
        setEndDate(today);
        return; 
      }
      if (startDate && endDate) {
         const role = selectedRoles.includes("A") ? "assignee" : "developer";
        dispatch(Actions.getKanbanTickets(selectedProjectKey, startDate, endDate, role));
      }
    }
  };

  fetchBoardAndData();
}, [selectedProjectKey, startDate, endDate, dispatch, selectedRoles]);



  useEffect(() => {
    dispatch(Actions.getSprints());
  }, [dispatch]);

  useEffect(() => {
  dispatch(Actions.getProjects());
}, [dispatch]);

  const handleProjectChange = (e) => {
    const newProjectKey = e.target.value;
      setSelectedProjectKey(newProjectKey);
      setSelectedSprint([]);
      setStartDate("");
      setEndDate("");
      setSelectedPriorities([]);
      setSelectedIssueType("");
      setSelectedRoles(["A"]);
      setRole("assignee");
      setSideBarContent([]);
      setallTicketsByEmployee([]);
      setNodes([]);
      setEdges([]);
      setSelectedNodeId(null);
      setRecentFilter("");           
      setKanbanRecentFilter("");
 };


  useEffect(() => {
    if (Object.values(sprintTickets).length === 0) {
      return;
    }
    for (let employee in sprintTickets) {
      sprintTickets[employee].ticketList.forEach((ticket) => {
        if (!ticketDetails[ticket.key]) {
          dispatch(Actions.getTicketDetails(ticket.key));
        }
      });
    }
  }, [sprintTickets]);

  const ticketDetailsLength = Object.keys(ticketDetails).length;
 
  const handleSprintChange = (event) => {
    const value = event.target.value;
    setSelectedSprint(Array.isArray(value) ? value : []);
  };

  const handleDateChange = (event, type) => {
    if (type === "start") {
      setStartDate(event.target.value);
    } else {
      setEndDate(event.target.value);
    }
  };

  const handleRoleChange = (event, newRole) => {
    if (newRole !== null) {
      setRole(newRole);
      let roles;
      switch (newRole) {
        case "assignee":
          roles = ["A"];
          break;
        case "developer":
          roles = ["D"];
          break;
        default:
          roles = ["A"];
      }

      setSelectedRoles(roles);
    }
  };

  const handleShowSprint = () => {
  if (projectBoardType !== 'scrum') return;
  if (selectedSprint.length === 0) {
    alert("Please select at least one sprint.");
    return;
  }
  const roles = selectedRoles.map((role) =>
    role === "A" ? "assignee" : "developer"
  );
  dispatch(Actions.getSprintTickets(selectedSprint.join(","), roles.join(",")));
};

  useEffect(() => {
    setSideBarContent(sprintTickets);
    setallTicketsByEmployee(sprintTickets);
  }, [sprintTickets, ticketDetailsLength]);

  const handleShowDateRange = () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    const roles = selectedRoles.map((role) =>
      role === "A" ? "assignee" : "developer"
    );
    dispatch(
      Actions.getTicketsByDateRange(startDate, endDate, roles.join(","))
    );
  };

  useEffect(() => {
    if (ticketsByDateRange) {
      setSideBarContent(ticketsByDateRange);
      setallTicketsByEmployee(ticketsByDateRange);
    }
  }, [ticketsByDateRange, ticketDetailsLength]);

  useEffect(() => {
    if (sprintTickets) {
      let filteredTickets = sprintTickets;

      if (selectedPriorities.length > 0) {
        filteredTickets = Object.fromEntries(
          Object.entries(sprintTickets).map(([employee, details]) => {
            const filteredTicketList = details.ticketList.filter((ticket) =>
              selectedPriorities.includes(ticket.priority)
            );

            return [employee, { ...details, ticketList: filteredTicketList }];
          })
        );

        // Remove employees with no matching tickets
        filteredTickets = Object.fromEntries(
          Object.entries(filteredTickets).filter(
            ([_, details]) => details.ticketList.length > 0
          )
        );
      }

      // Update only priority-filtered tickets
      setSideBarContent(filteredTickets);
      setallTicketsByEmployee(filteredTickets);
    }
  }, [sprintTickets, selectedPriorities]);

  const DAYS = { "1d": 1, "7d": 7 };

  useEffect(() => {
  const applyFilters = (tickets) => {
    let filteredTickets = { ...tickets };

    // 1. Filter by priorities and issue type
    if (selectedPriorities.length > 0 || selectedIssueType) {
      filteredTickets = Object.fromEntries(
        Object.entries(filteredTickets).map(([employee, details]) => {
          const filteredList = details.ticketList.filter((ticket) =>
            (selectedPriorities.length === 0 || selectedPriorities.includes(ticket.priority)) &&
            (!selectedIssueType || ticket.issuetype === selectedIssueType)
          );
          return [employee, { ...details, ticketList: filteredList }];
        })
      );

      // Remove employees with no matching tickets
      filteredTickets = Object.fromEntries(
        Object.entries(filteredTickets).filter(
          ([_, details]) => details.ticketList.length > 0
        )
      );
    }
    if (recentFilter && DAYS[recentFilter]) {
      filteredTickets = filterRecentByStatus(filteredTickets, DAYS[recentFilter]);
    }

    if (kanbanRecentFilter && DAYS[kanbanRecentFilter]) {
      filteredTickets = filterRecentByStatus(filteredTickets, DAYS[kanbanRecentFilter]);
    }

    return filteredTickets;
  };

  if (projectBoardType === "kanban" && startDate && endDate && kanbanTickets) {
    const filtered = applyFilters(kanbanTickets);
    setSideBarContent(filtered);
    setallTicketsByEmployee(filtered);
    renderNodesAndEdges({ ticketsByEmployee: filtered }, selectedProjectKey);
    setSelectedNodeId(null);
  } else if (projectBoardType === "scrum" && sprintTickets) {
    const filtered = applyFilters(sprintTickets);
    const final = Object.keys(filtered).length > 0 ? filtered : sprintTickets;
    setSideBarContent(final);
    setallTicketsByEmployee(final);
    renderNodesAndEdges({ ticketsByEmployee: final }, selectedSprint);
    setSelectedNodeId(null);
  }
  }, [
  sprintTickets,
  kanbanTickets,
  startDate,
  endDate,
  selectedPriorities,
  selectedIssueType,
  ticketDetailsLength,
  selectedProjectKey,
  selectedSprint,
  projectBoardType,
  recentFilter, 
  kanbanRecentFilter,
  ]);


  const handleMoreClick = (ticketId) => {
    if (expandedTickets[ticketId]) {
      setExpandedTickets((prev) => {
        const updated = { ...prev };
        delete updated[ticketId];
        return updated;
      });
      return;
    }

    if (!ticketDetails[ticketId]) {
      dispatch(Actions.getTicketDetails(ticketId));
    }

    setExpandedTickets((prev) => ({ ...prev, [ticketId]: true }));
  };
  const renderNodesAndEdges = (data, rootLabel) => {
    const canvasWidth = 2000;
    const canvasHeight = 1500;
    const baseRadius = 48;
    const radiusIncrement = 0.1;
    const minimumSpacing = 40;
    const employeeCircleSize = 50;

    const getTicketEstimateTimeStr = (ticket) =>
    ticketDetails[ticket.key]?.originalEstimates ??
    (ticket.originalEstimateHours !== undefined
      ? `${ticket.originalEstimateHours}h`
      : "0h");

    // Calculate total tickets and estimates
    let totalTickets = 0;
    let totalEstimateTime = "";

    Object.entries(data.ticketsByEmployee).forEach(([_, details]) => {
      // Count only non-removed tickets
      const nonRemovedTickets = details.ticketList.filter(
        (ticket) => ticket.status !== "Removed"
      );
      totalTickets += nonRemovedTickets.length;

      // Add up estimates for each non-removed ticket
      nonRemovedTickets.forEach((ticket) => {
        const time = getTicketEstimateTimeStr(ticket);
        totalEstimateTime += time + " ";
      });
    });

    const processedTotalTime = processTime(totalEstimateTime);
    const calculateTimeValue = (timeStr) => {
      let totalMinutes = 0;
      const matches = timeStr.match(/(\d+)([wdhm])/g) || [];
    
      matches.forEach((match) => {
        const value = parseInt(match.match(/\d+/)[0]);
        const unit = match.match(/[wdhm]$/)[0];
    
        switch (unit) {
          case 'w': totalMinutes += value * 2400; break; // weeks to minutes
          case 'd': totalMinutes += value * 480; break; // days to minutes
          case 'h': totalMinutes += value * 60; break; // hours to minutes
          case 'm': totalMinutes += value; break; // minutes
          default: break;
        }
      });
    
      return totalMinutes;
    };
    
    const countTicketsByStatus = (ticketsByEmployee, status) => {
      let count = 0;
      Object.values(ticketsByEmployee).forEach(details => {
        count += details.ticketList.filter(ticket => ticket.status === status).length;
      });
      return count;
    };
    
    const calculateTimeByStatus = (ticketsByEmployee, status) => {
      let totalTimeStr = "";
    
      Object.values(ticketsByEmployee).forEach(details => {
        details.ticketList.forEach(ticket => {
          if (ticket.status === status) {
            totalTimeStr += getTicketEstimateTimeStr(ticket);
            totalTimeStr += ' ';
          }
        });
      });
    
      return processTime(totalTimeStr);
    };
    
    const calculateSprintProgress = (ticketsByEmployee, processedTotalTime) => {
      let totalDoneMinutes = 0;
    
      Object.values(ticketsByEmployee).forEach((details) => {
        details.ticketList.forEach((ticket) => {
          if (["Done", "Blocked"].includes(ticket.status)) {
            const timeStr = getTicketEstimateTimeStr(ticket);
            totalDoneMinutes += calculateTimeValue(timeStr);
          }
        });
      });
    
      const totalOrderMinutes = calculateTimeValue(processedTotalTime);
    
      return totalOrderMinutes
        ? ((totalDoneMinutes / totalOrderMinutes) * 100).toFixed(2)
        : '0';
    };

    // Calculate total time in minutes
    const totalTimeMinutes = calculateTimeValue(processedTotalTime);

    // Helper function to get status data (count, time, percentage)
    const getStatusData = (status) => {
      const count = countTicketsByStatus(data.ticketsByEmployee, status);
      const timeStr = calculateTimeByStatus(data.ticketsByEmployee, status);
      const timeMinutes = calculateTimeValue(timeStr);
      const percentage = totalTimeMinutes ? 
        ((timeMinutes / totalTimeMinutes) * 100).toFixed(1) : 0;
      return { count, timeStr, percentage };
    };

    // Get data for each status
    const inProgressData = getStatusData("In Progress");
    const inReviewData = getStatusData("In Review");
    const todoData = getStatusData("To Do");
    const doneData = getStatusData("Done");
    const readyForReviewData = getStatusData("Ready for review");


    const rootNode = {
      id: "root",
      type: "input",
      data: {
        label: (
          <div style={{ textAlign: "center" }}>
        <Typography variant="subtitle1" sx={{ color: "#000000", fontSize: "20px" }}>
          {`Sprint ${rootLabel}`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`Total Tickets: ${totalTickets}`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`Total Time: ${processedTotalTime}`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`Sprint Progress: ${calculateSprintProgress(data.ticketsByEmployee, processedTotalTime)}%`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`In Progress - Tickets: ${inProgressData.count}, Time: ${inProgressData.timeStr} (${inProgressData.percentage}%)`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`Ready For Review - Tickets: ${readyForReviewData.count}, Time: ${readyForReviewData.timeStr} (${readyForReviewData.percentage}%)`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`In Review - Tickets: ${inReviewData.count}, Time: ${inReviewData.timeStr} (${inReviewData.percentage}%)`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`Todo - Tickets: ${todoData.count}, Time: ${todoData.timeStr} (${todoData.percentage}%)`}
        </Typography>
        <Typography variant="body2" sx={{ color: "#000000 !important", fontSize: "20px !important" }}>
          {`Done - Tickets: ${doneData.count}, Time: ${doneData.timeStr} (${doneData.percentage}%)`}
        </Typography>
      </div>
        ),
      },
      position: { x: canvasWidth / 2 - 75, y: canvasHeight / 2 -400 },
      style: {
        width: 540,
        height: 280,
        borderRadius: "10px",
        backgroundColor: "#f3795e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #90caf9",
        color: "#000000",
      },
    };
    const employeeWithDoneTime = Object.entries(data.ticketsByEmployee).map(
      ([employee, details]) => {
        const ticketList = details.ticketList;
        let totalDoneTimeValue = 0;

        // Convert the time string to a numeric value for sorting
        const calculateTimeValue = (timeStr) => {
          let totalMinutes = 0;
          const matches = timeStr.match(/(\d+)([wdhm])/g) || [];

          matches.forEach((match) => {
            const value = parseInt(match.match(/\d+/)[0]);
            const unit = match.match(/[wdhm]$/)[0];

            switch (unit) {
              case "w":
                totalMinutes += value * 5 * 8 * 60;
                break; // 1w = 5d = 40h = 2400m
              case "d":
                totalMinutes += value * 8 * 60;
                break; // 1d = 8h = 480m
              case "h":
                totalMinutes += value * 60;
                break; // 1h = 60m
              case "m":
                totalMinutes += value;
                break;
            }
          });

          return totalMinutes;
        };

        ticketList.forEach((ticket) => {
          if (ticket.status === "Done" || ticket.status === "Blocked") {
            const timeStr =
              getTicketEstimateTimeStr(ticket);
            totalDoneTimeValue += calculateTimeValue(timeStr);
          }
        });

        return { employee, details, totalDoneTimeValue };
      }
    );

    // Sort employees by their done time in descending order
    employeeWithDoneTime.sort(
      (a, b) => b.totalDoneTimeValue - a.totalDoneTimeValue
    );

    // Replace the regular iteration with the sorted data
    const sortedEmployees = employeeWithDoneTime.map((item) => [
      item.employee,
      item.details,
    ]);

    // Add total summary boxes layer
    const summaryNodes = [];
    const employeeNodes = [];
    const thirdLevelNodes = [];
    const newEdges = [];

    const employeeRadii = Object.entries(data.ticketsByEmployee).map(
      ([_, details]) => {
        const summary = details.summary;
        const totalTickets =
          (summary["To Do"] || 0) +
          (summary["In Progress"] || 0) +
          (summary["In Review"] || 0) +
          (summary["Done"] || 0) +
          (summary["Blocked"] || 0);
        // (summary["Removed"] || 0);
        return (
          baseRadius + baseRadius * radiusIncrement * Math.sqrt(totalTickets)
        );
      }
    );

    const totalWidth = employeeRadii.reduce(
      (sum, radius, index) =>
        sum +
        2 * radius +
        (index < employeeRadii.length - 1 ? minimumSpacing : 0),
      0
    );

    let currentX = (canvasWidth - totalWidth) / 2;

    sortedEmployees.forEach(([employee, details], index) => {
      const shortName = employee
        .split(" ")
        .map((part) => part[0].toUpperCase())
        .join("");

      const summary = details.summary;
      const ticketList = details.ticketList;

      const toDoTickets = ticketList.filter(ticket => ticket.status === "To Do").length;
      const inProgressTickets = ticketList.filter(ticket => ticket.status === "In Progress").length;
      const inReviewTickets = ticketList.filter(ticket => ticket.status === "In Review").length;
      const doneTickets = ticketList.filter(ticket => ticket.status === "Done").length;
      const blockedTickets = ticketList.filter(ticket => ticket.status === "Blocked").length;
      const readyForReviewTickets = ticketList.filter(ticket => ticket.status === "Ready for review").length;

      const totalDone = doneTickets + blockedTickets; // "Done" + "Blocked" tickets

      let toDoTime = "";
      let inProgressTime = "";
      let inReviewTime = "";
      let doneTime = "";
      let blockedTime = "";
      let removedTime = "";
      let totalDoneTime = "";
      let ticketKey = "";
      let readyForReviewTime = "";

      ticketList.forEach((ticket) => {
        ticketKey = ticket.key;
        if (ticket.status === "To Do") {
          toDoTime += getTicketEstimateTimeStr(ticket) + " ";
        } else if (ticket.status === "In Progress") {
          inProgressTime += getTicketEstimateTimeStr(ticket) + " ";
        } else if (ticket.status === "In Review") {
          inReviewTime += getTicketEstimateTimeStr(ticket) + " ";
        } else if (ticket.status === "Done") {
          doneTime += getTicketEstimateTimeStr(ticket) + " ";
        } else if (ticket.status === "Blocked") {
          blockedTime += getTicketEstimateTimeStr(ticket) + " ";
        } else if (ticket.status === "Ready for review") {
          readyForReviewTime += getTicketEstimateTimeStr(ticket) + " ";
        }
      });

      readyForReviewTime = processTime(readyForReviewTime);
      toDoTime = processTime(toDoTime);
      inProgressTime = processTime(inProgressTime);
      inReviewTime = processTime(inReviewTime);
      totalDoneTime = processTime(doneTime + blockedTime);

      const timeScalingFactor = 0.001; // Adjust this value to control the overall size

      const maxRadius = baseRadius + baseRadius * radiusIncrement * Math.log(totalTimeMinutes * timeScalingFactor + 1);
      const toDoCircleSize = baseRadius + baseRadius * radiusIncrement * Math.log(calculateTimeValue(toDoTime) * timeScalingFactor + 1);
      const inProgressCircleSize = baseRadius + baseRadius * radiusIncrement * Math.sqrt(calculateTimeValue(inProgressTime) * timeScalingFactor);
      const inReviewCircleSize = baseRadius + baseRadius * radiusIncrement * Math.sqrt(calculateTimeValue(inReviewTime) * timeScalingFactor);
      const totalDoneCircleSize = baseRadius + baseRadius * radiusIncrement * Math.sqrt(calculateTimeValue(totalDoneTime) * timeScalingFactor);
      const readyForReviewCircleSize = baseRadius + baseRadius * radiusIncrement * Math.sqrt(calculateTimeValue(readyForReviewTime) * timeScalingFactor);


      const bgColor = toDoTickets === 0 ? "#ffcccc" : "#ADBBDA";

      // "To Do" Node
      const employeeNode = {
        id: shortName,
        data: {
          label: (
            <div title={employee} style={{ textAlign: "center" }}>
              <Typography variant="subtitle2">{shortName} </Typography>
              <Typography>To Do: {toDoTickets}</Typography>
              <Typography>Time: {toDoTime}</Typography>
            </div>
          ),
        },
        position: { x: currentX + maxRadius, y: canvasHeight / 2 + 250 },
        style: {
          width: toDoCircleSize * 2,
          height: toDoCircleSize * 2,
          borderRadius: "50%",
          backgroundColor: bgColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ccc",
        },
      };

      employeeNodes.push(employeeNode);
      newEdges.push({
        id: `e-root-${shortName}`,
        source: "root",
        target: shortName,
      });

      // "In Progress" Node
      const inProgressNode = {
        id: `${shortName}-progress`,
        data: {
          label: (
            <div
              title={`${employee} - In Progress`}
              style={{ textAlign: "center" }}
            >
              <Typography variant="subtitle2">{`In Progress`}</Typography>
              <Typography>Tickets: {inProgressTickets}</Typography>
              <Typography>Time: {inProgressTime}</Typography>
            </div>
          ),
        },
        position: { x: currentX + maxRadius, y: canvasHeight / 2 + 400 },
        style: {
          width: inProgressCircleSize * 2,
          height: inProgressCircleSize * 2,
          borderRadius: "50%",
          backgroundColor: "#cce5ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #007bff",
        },
      };

      thirdLevelNodes.push(inProgressNode);
      newEdges.push({
        id: `e-${shortName}-progress`,
        source: shortName,
        target: `${shortName}-progress`,
      });

      const readyForReviewNode = {
        id: `${shortName}-ready`,
        data: {
          label: (
            <div title={`${employee} - Ready for review`} style={{ textAlign: "center" }}>
              <Typography variant="subtitle2">Ready For Review</Typography>
              <Typography>Tickets: {readyForReviewTickets}</Typography>
              <Typography>Time: {readyForReviewTime}</Typography>
            </div>
          ),
        },
        position: { x: currentX + maxRadius, y: canvasHeight / 2 + 550 },
        style: {
          width: readyForReviewCircleSize * 2,
          height: readyForReviewCircleSize * 2,
          borderRadius: "50%",
          backgroundColor: statusColors["Ready for review"].background,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #f1c40f",
        },
      };

      thirdLevelNodes.push(readyForReviewNode);
      newEdges.push({
        id: `e-${shortName}-progress-ready`,
        source: `${shortName}-progress`,
        target: `${shortName}-ready`,
      });


      // "In Review" Node
      const inReviewNode = {
        id: `${shortName}-review`,
        data: {
          label: (
            <div
              title={`${employee} - In Review`}
              style={{ textAlign: "center" }}
            >
              <Typography variant="subtitle2">{`In Review`}</Typography>
              <Typography>Tickets: {inReviewTickets}</Typography>
              <Typography>Time: {inReviewTime}</Typography>
            </div>
          ),
        },
        position: { x: currentX + maxRadius, y: canvasHeight / 2 + 700 },
        style: {
          width: inReviewCircleSize * 2,
          height: inReviewCircleSize * 2,
          borderRadius: "50%",
          backgroundColor: "#f9e79f",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #f1c40f",
        },
      };

      thirdLevelNodes.push(inReviewNode);
      newEdges.push({
        id: `e-${shortName}-ready-review`,
        source: `${shortName}-ready`,
        target: `${shortName}-review`,
      });

      const doneNode = {
        id: `${shortName}-done`,
        data: {
          label: (
            <div title={`${employee} - Done`} style={{ textAlign: "center" }}>
              <Typography variant="subtitle2">{`Done`}</Typography>
              <Typography>{`Done: ${doneTickets + blockedTickets}`}</Typography>
              <Typography>{`Time: ${totalDoneTime}`}</Typography>
            </div>
          ),
        },
        position: { x: currentX + maxRadius, y: canvasHeight / 2 + 870 },
        style: {
          width: totalDoneCircleSize * 2,
          height: totalDoneCircleSize * 2,
          borderRadius: "50%",
          backgroundColor: "#d4edda",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid #28a745",
        },
      };

      thirdLevelNodes.push(doneNode);
      newEdges.push({
        id: `e-${shortName}-review-done`,
        source: `${shortName}-review`,
        target: `${shortName}-done`,
      });

      const calculateEmployeeSprintProgress = (details) => {
        let totalDoneMinutes = 0;
        let totalEmployeeMinutes = 0;
      
        details.ticketList.forEach((ticket) => {
          if (ticket.status !== "Removed") {
            const timeStr = getTicketEstimateTimeStr(ticket);
            const minutes = calculateTimeValue(timeStr);
            totalEmployeeMinutes += minutes;
      
            if (["Done", "Blocked"].includes(ticket.status)) {
              totalDoneMinutes += minutes;
            }
          }
        });
      
        return totalEmployeeMinutes
          ? ((totalDoneMinutes / totalEmployeeMinutes) * 100).toFixed(2)
          : "0";
      };
      

      // Calculate total tickets and time
      const totalTickets = details.ticketList.filter(
        (ticket) => ticket.status !== "Removed"
      ).length;
      let totalTime = "";

      details.ticketList.forEach((ticket) => {
        if (ticket.status !== "Removed") {
          const time = getTicketEstimateTimeStr(ticket);
         totalTime += time + " ";
        }
      });

      const processedTotalTime = processTime(totalTime);
      const sprintProgressPercentage = calculateEmployeeSprintProgress(details);

      // Create summary box node
      const summaryNode = {
        id: `${shortName}-summary`,
        data: {
          label: (
            <div
              title={`${employee} - Total Summary`}
              style={{ textAlign: "center" }}
            >
              <Typography variant="subtitle2">{shortName}</Typography>
              <Typography>Total Tickets: {totalTickets}</Typography>
              <Typography>Total Time: {processedTotalTime}</Typography>
              <Typography>Sprint Progress: {sprintProgressPercentage}%</Typography>
            </div>
          ),
        },
        position: {
          x: currentX + maxRadius,
          y: canvasHeight / 2 + (index % 2 === 0 ? 0 : 100), // Alternate vertical offset
        },
        style: {
          width: 180,
          height: 100,
          backgroundColor: "#e3f2fd",
          border: "2px solid #1976d2",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px",
        },
      };

      summaryNodes.push(summaryNode);

      // Add edges from root to summary and summary to employee node
      newEdges.push({
        id: `e-root-${shortName}-summary`,
        source: "root",
        target: `${shortName}-summary`,
      });
      newEdges.push({
        id: `e-${shortName}-summary-employee`,
        source: `${shortName}-summary`,
        target: shortName,
      });

      // Remove the direct edge from root to employee node
      const directEdgeIndex = newEdges.findIndex(
        (edge) => edge.id === `e-root-${shortName}`
      );
      if (directEdgeIndex !== -1) {
        newEdges.splice(directEdgeIndex, 1);
      }

      // const oldEdgeIndex = newEdges.findIndex(e => e.id === `e-${shortName}-progress-review`);
      // if (oldEdgeIndex > -1) newEdges.splice(oldEdgeIndex, 1);

      currentX += 2 * maxRadius + minimumSpacing;
    });

    const footNode = {
      id: "foot",
      type: "output",
      data: { label: `Sprint ${rootLabel} - Summary` },
      position: { x: canvasWidth / 2 - 75, y: canvasHeight / 2 + 1150 },
      style: {
        width: 200,
        height: 100,
        borderRadius: "10px",
        backgroundColor: "#e8f5e9",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px solid #66bb6a",
      },
    };

    employeeNodes.forEach((node) => {
      newEdges.push({
        id: `e-${node.id}-foot`,
        source: `${node.id}-done`,
        target: "foot",
      });
    });

    const layoutNodes = [
      rootNode,
      ...summaryNodes,
      ...employeeNodes,
      ...thirdLevelNodes,
      footNode,
    ];
  
    // Then create edges that reference these nodes
    const layoutEdges = newEdges;
  
    // Atomic state update for nodes and edges
    setNodes(layoutNodes);
    setEdges(layoutEdges);
  };

  const onNodeClick = (event, node) => {
    const nodeId = node.id;
    setSelectedNodeId((prevId) => (prevId === nodeId ? null : nodeId));
    // Add handling for summary nodes
    if (nodeId.endsWith("-summary")) {
      const employeeName = node.data.label.props.title.replace(
        " - Total Summary",
        ""
      );
      const employeeTickets =
        allTicketsByEmployee[employeeName]?.ticketList.filter(
          (ticket) => ticket.status !== "Removed"
        ) || [];

      const summaryContent = {
        [employeeName]: {
          ticketList: employeeTickets,
          summary: {
            total: employeeTickets.length,
            "To Do": employeeTickets.filter(
              (ticket) => ticket.status === "To Do"
            ).length,
            "In Progress": employeeTickets.filter(
              (ticket) => ticket.status === "In Progress"
            ).length,
            "In Review": employeeTickets.filter(
              (ticket) => ticket.status === "In Review"
            ).length,
            Done: employeeTickets.filter((ticket) => ticket.status === "Done")
              .length,
          },
        },
      };

      setSideBarContent(summaryContent);
      return;
    }

    if (nodeId === "root") {
      const filteredTicketsByEmployee = {};
      for (const employeeName in allTicketsByEmployee) {
        filteredTicketsByEmployee[employeeName] = {
          ...allTicketsByEmployee[employeeName],
          ticketList: allTicketsByEmployee[employeeName].ticketList.filter(
            (ticket) => ticket.status !== "Removed"
          ),
        };
      }
      setSideBarContent(filteredTicketsByEmployee);
      return;
    } else if (nodeId === "foot") {
      // When clicked on foot, show only tickets with status "Done"
      const footSummary = {};
      for (const employeeName in allTicketsByEmployee) {
        const employeeTickets =
          allTicketsByEmployee[employeeName].ticketList || [];
        const filteredTickets = employeeTickets.filter(
          (ticket) => ticket.status === "Done"
        );

        // Prepare the summary data (for tickets with status "Done")
        const doneSummary = {
          Done: filteredTickets.length,
          total_running_tickets:
            filteredTickets.length +
            employeeTickets.filter((ticket) => ticket.status !== "Done").length,
        };

        footSummary[employeeName] = {
          ticketList: filteredTickets,
          summary: doneSummary,
        };
      }
      setSideBarContent(footSummary);
      return;
    }

    let employeeName = node.data.label.props.title;

    // Handle the "Done" node level (status includes "Done", "Blocked", "Removed")
    if (nodeId.endsWith("-done")) {
      employeeName = employeeName.replace(" - Done", "");
      const employeeTickets =
        allTicketsByEmployee[employeeName]?.ticketList || [];

      // Filter tickets with status "Done", "Blocked", or "Removed"
      const filteredTickets = employeeTickets.filter((ticket) =>
        // ["Done", "Blocked", "Removed"].includes(ticket.status)
        ["Done", "Blocked"].includes(ticket.status)
      );

      // Prepare the summary data
      const doneSummary = {
        Done: filteredTickets.length,
        total_running_tickets:
          filteredTickets.length +
          employeeTickets.filter(
            // (ticket) => !["Done", "Blocked", "Removed"].includes(ticket.status)
            (ticket) => !["Done", "Blocked"].includes(ticket.status)
          ).length,
      };

      // Construct the updated sideBarContent
      const updatedSideBarContent = {
        [employeeName]: {
          ticketList: filteredTickets,
          summary: doneSummary,
        },
      };

      setSideBarContent(updatedSideBarContent);
      return;
    }

    // Handle the "In Progress" node level
    if (nodeId.endsWith("-progress")) {
      employeeName = employeeName.replace(" - In Progress", "");
      const employeeTickets =
        allTicketsByEmployee[employeeName]?.ticketList || [];

      // Filter tickets with status "In Progress"
      const filteredTickets = employeeTickets.filter(
        (ticket) => ticket.status === "In Progress"
      );

      const progressSummary = {
        "In Progress": filteredTickets.length,
        total_running_tickets:
          filteredTickets.length +
          employeeTickets.filter((ticket) => ticket.status !== "In Progress")
            .length,
      };

      const updatedSideBarContent = {
        [employeeName]: {
          ticketList: filteredTickets,
          summary: progressSummary,
        },
      };

      setSideBarContent(updatedSideBarContent);
      return;
    }

    // Inside onNodeClick function
    if (nodeId.endsWith("-ready")) {
      employeeName = employeeName.replace(" - Ready for review", "");
      const employeeTickets = allTicketsByEmployee[employeeName]?.ticketList || [];
      const filteredTickets = employeeTickets.filter(
        ticket => ticket.status === "Ready for review"
      );

      const readySummary = {
        "Ready for review": filteredTickets.length,
        total_running_tickets: filteredTickets.length + 
          employeeTickets.filter(ticket => ticket.status !== "Ready for review").length,
      };

      const updatedSideBarContent = {
        [employeeName]: {
          ticketList: filteredTickets,
          summary: readySummary,
        },
      };

      setSideBarContent(updatedSideBarContent);
      return;
    }

    // Handle the "Review/Ready for Review" node level
    if (nodeId.endsWith("-review")) {
      employeeName = employeeName.replace(" - In Review", "");
      const employeeTickets = allTicketsByEmployee[employeeName]?.ticketList || [];
      
      // Only include tickets with status "In Review"
      const filteredTickets = employeeTickets.filter(ticket => 
        ticket.status === "In Review"
      );

      const reviewSummary = {
        "In Review": filteredTickets.length,
        total_running_tickets:
          filteredTickets.length +
          employeeTickets.filter(ticket => ticket.status !== "In Review").length,
      };

      const updatedSideBarContent = {
        [employeeName]: {
          ticketList: filteredTickets,
          summary: reviewSummary,
        },
      };

      setSideBarContent(updatedSideBarContent);
      return;
    } else {
      // employeeName = employeeName.replace(" - To Do", "");
      const employeeTickets =
        allTicketsByEmployee[employeeName]?.ticketList || [];

      // Filter tickets with status "To Do"
      const filteredTickets = employeeTickets.filter(
        (ticket) => ticket.status === "To Do"
      );

      const todoSummary = {
        "To Do": filteredTickets.length,
        total_running_tickets:
          filteredTickets.length +
          employeeTickets.filter((ticket) => ticket.status !== "To Do").length,
      };

      const updatedSideBarContent = {
        [employeeName]: {
          ticketList: filteredTickets,
          summary: todoSummary,
        },
      };

      setSideBarContent(updatedSideBarContent);
      return;
    }
  };

  const onNodesChange = useCallback(
    (changes) =>{ setNodes((nds) => applyNodeChanges(changes, nds))
    },
    [setNodes]
  );
  const onEdgesChange = useCallback(
    (changes) => {setEdges((eds) => applyEdgeChanges(changes, eds))
    },
    [setEdges]
  );

  const processTime = (time) => {
    const timeUnits = { w: 0, d: 0, h: 0, m: 0 };
    const hoursArray = time.split(" ");

    hoursArray.forEach((item) => {
      const match = item.match(/(\d+)([wdhm])/);
      if (match) {
        const value = parseInt(match[1], 10);
        const unit = match[2];
        timeUnits[unit] += value;
      }
    });

    // 60 min = 1 hour, 8 hours = 1 day, 5 days = 1 week
    if (timeUnits.m >= 60) {
      timeUnits.h += Math.floor(timeUnits.m / 60);
      timeUnits.m %= 60;
    }
    if (timeUnits.h >= 8) {
      timeUnits.d += Math.floor(timeUnits.h / 8);
      timeUnits.h %= 8;
    }
    if (timeUnits.d >= 5) {
      timeUnits.w += Math.floor(timeUnits.d / 5);
      timeUnits.d %= 5;
    }

    // Format the result
    const result = [];
    if (timeUnits.w > 0) result.push(`${timeUnits.w}w`);
    if (timeUnits.d > 0) result.push(`${timeUnits.d}d`);
    if (timeUnits.h > 0) result.push(`${timeUnits.h}h`);
    if (timeUnits.m > 0) result.push(`${timeUnits.m}m`);

    return result.join(" ") || "N/A";
  };

  const toggleLeftSidebar = () => {
    setIsLeftSidebarOpen(!isLeftSidebarOpen);
  };

  const handleSearchResultClick = (employeeName) => {
    const shortName = employeeName
      .split(" ")
      .map((part) => part[0].toUpperCase())
      .join("");
    setSelectedNodeId(shortName);
    
    const employeeTickets = allTicketsByEmployee[employeeName]?.ticketList || [];
    const filteredTickets = employeeTickets.filter(ticket => ticket.status === "To Do");
    
    const todoSummary = {
      "To Do": filteredTickets.length,
      total_running_tickets: filteredTickets.length + 
        employeeTickets.filter(ticket => ticket.status !== "To Do").length,
    };

    const updatedSideBarContent = {
      [employeeName]: {
        ticketList: filteredTickets,
        summary: todoSummary,
      },
    };

    setSideBarContent(updatedSideBarContent);
    
  };

  const handleSearchClick = (event) => {
    setSearchAnchorEl(event.currentTarget);
  };

  const handleSearchClose = () => {
    setSearchAnchorEl(null);
  };


  return (
    <div className="sprint-dashboard">
      {/* Left Sidebar */}
      <div className={`left-sidebar ${isLeftSidebarOpen ? "open" : ""}`}>
        <Typography variant="h6" gutterBottom>
          Filters
        </Typography>
        {/* 9. Kanban time-filter */}
        {projectBoardType === "kanban" && (
          <div className="filter-section">
            <div className="filter-section-title">Kanban Updated</div>
            <Select
              value={kanbanRecentFilter}
              onChange={e => setKanbanRecentFilter(e.target.value)}
              displayEmpty
              fullWidth
              size="small"
            >
              <MenuItem value="">Show All</MenuItem>
              <MenuItem value="1d">Last 1 Day</MenuItem>
              <MenuItem value="7d">Last 7 Days</MenuItem>
            </Select>
          </div>
        )}
        
        {projectBoardType === "scrum" && (
          <div className="filter-section">
            <div className="filter-section-title">Updated Filter</div>
            <Select
              value={recentFilter}
              onChange={(e) => setRecentFilter(e.target.value)}
              displayEmpty
              fullWidth
              size="small"
            >
              <MenuItem value="">Show All</MenuItem>
              <MenuItem value="1d">Last 1 Day</MenuItem>
              <MenuItem value="7d">Last 7 Days</MenuItem>
            </Select>
          </div>
        )}
          {/* Project Filter */}
          <div className="filter-section">
            <div className="filter-section-title">Project</div>
            <Select
                value={selectedProjectKey}
                onChange={handleProjectChange}
                displayEmpty
                fullWidth
                size="small"
              >
                <MenuItem value="">All Projects</MenuItem>
                {allProjects
                  .filter(
                    (project) =>
                      project.name === "Engineering - Production" ||
                      project.name === "Engineering - R&D"
                  )
                  .map((project) => (
                    <MenuItem key={project.id} value={project.key}>
                      {project.name}
                    </MenuItem>
                  ))}
              </Select>
          </div>

          {/* 1. Sprint Selection */}
          {projectBoardType === "scrum" && (
          <div className="filter-section">
          <div className="filter-section-title">Sprint Selection</div>
          <Select
              multiple
              value={selectedSprint}
              onChange={handleSprintChange}
              displayEmpty
              fullWidth
              size="small"
              disabled={projectBoardType === 'kanban'}
              renderValue={(selected) => {
                if (selected.length === 0) return "Select Sprint(s)";
                return selected
                  .map((id) => sprints.find((s) => s.sprintId === id)?.name)
                  .join(", ");
              }}
            >
              <MenuItem value="" disabled>
                Select Sprint(s)
              </MenuItem>
              {sprints.map((sprint) => (
                <MenuItem key={sprint.sprintId} value={sprint.sprintId}>
                  <Checkbox checked={selectedSprint.indexOf(sprint.sprintId) > -1} />
                  <ListItemText primary={sprint.name} />
                </MenuItem>
              ))}
            </Select>
        </div>
        )}
        {/* 2. Priority */}
        <div className="filter-section">
          <div className="filter-section-title">Priority</div>
          <Select
            multiple
            value={selectedPriorities}
            onChange={(event) => setSelectedPriorities(event.target.value)}
            displayEmpty
            renderValue={(selected) =>
              selected.length ? selected.join(", ") : "All Priorities"
            }
            fullWidth
            size="small"
          >
            <MenuItem value="Highest">
              <Checkbox checked={selectedPriorities.includes("Highest")} />
              <ListItemText primary="Highest" />
            </MenuItem>
            <MenuItem value="High">
              <Checkbox checked={selectedPriorities.includes("High")} />
              <ListItemText primary="High" />
            </MenuItem>
            <MenuItem value="Medium">
              <Checkbox checked={selectedPriorities.includes("Medium")} />
              <ListItemText primary="Medium" />
            </MenuItem>
            <MenuItem value="Low">
              <Checkbox checked={selectedPriorities.includes("Low")} />
              <ListItemText primary="Low" />
            </MenuItem>
          </Select>
        </div>

        {/* 3. Issue Type */}
        <div className="filter-section">
          <div className="filter-section-title">Issue Type</div>
          <Select
            value={selectedIssueType}
            onChange={(event) => setSelectedIssueType(event.target.value)}
            displayEmpty
            fullWidth
            size="small"
          >
            <MenuItem value="">All Issue Types</MenuItem>
            <MenuItem value="Epic" style={{ color: "#9056A0" }}>
              Epic
            </MenuItem>
            <MenuItem value="Task" style={{ color: "#4BADE8" }}>
              Task
            </MenuItem>
            <MenuItem value="Sub-task" style={{ color: "#96B3BE" }}>
              Sub-task
            </MenuItem>
            <MenuItem value="Bug" style={{ color: "#E94E4E" }}>
              Bug
            </MenuItem>
            {projectBoardType === "kanban" && (
              <MenuItem value="Story" style={{ color: "#36B37E" }}>
                Story
              </MenuItem>
            )}
          </Select>

        </div>

        {/* 4. Role */}
       
        <div className="filter-section">
          <div className="filter-section-title">Role</div>
          <ToggleButtonGroup
            value={role}
            exclusive
            onChange={handleRoleChange}
            aria-label="role selection"
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiToggleButton-root": {
                textTransform: "none",
                "&.Mui-selected": {
                  backgroundColor: "#1976d2",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#1565c0",
                  },
                },
              },
            }}
          >
            <ToggleButton value="assignee" aria-label="assignee">
              Assignee
            </ToggleButton>
            <ToggleButton value="developer" aria-label="developer">
              Developer
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
       

        {/* 5. Show Sprint Button */}
        {projectBoardType === "scrum" && (
        <div className="filter-section">
          <Button variant="contained" fullWidth onClick={handleShowSprint}>
            Show Sprint
          </Button>
        </div>
        )}
        {/* 6. Date Range */}
        <div className="filter-section">
          <div className="filter-section-title">Date Range</div>
          <TextField
            type="date"
            value={startDate}
            onChange={(event) => handleDateChange(event, "start")}
            label="Start Date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            size="small"
            sx={{ mb: 1 }}
          />
          <TextField
            type="date"
            value={endDate}
            onChange={(event) => handleDateChange(event, "end")}
            label="End Date"
            InputLabelProps={{ shrink: true }}
            fullWidth
            size="small"
            sx={{ mb: 1 }}
          />
        </div>

        {/* 7. Show Date Range Button */}
        {projectBoardType === "scrum" && (
        <div className="filter-section">
          <Button variant="contained" fullWidth onClick={handleShowDateRange}>
            Show by Date Range
          </Button>
        </div>
        )}
      </div>

      <div className="react-flow-container">
        <div className="flow-wrapper">
          {isLoading ? (
            <>
              <div className="loading-spinner">
                <CircularProgress /> {/* Add this line for the spinner */}
              </div>
            </>
          ) : (
            <ReactFlowProvider>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onNodeClick={onNodeClick}
        // onInit={() => reactFlowInstance.fitView()}
        fitView
      >
        <Background />
        <Controls />
        <MiniMap nodeStrokeWidth={3} />
      </ReactFlow>
    </ReactFlowProvider>
          )}
        </div>
        <div className="sidebar">
          <Button
            className="filter-toggle-btn"
            variant="contained"
            startIcon={<FilterListIcon />}
            onClick={toggleLeftSidebar}
          >
            Filters
          </Button>

          <Button
            className="search-btn"
            variant="contained"
            onClick={handleSearchClick}
          >
            All Employees
          </Button>

          {/* Employee Dropdown Menu */}
          <Menu
            anchorEl={searchAnchorEl}
            open={searchMenuOpen}
            onClose={handleSearchClose}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 280,
              },
            }}
          >
            {Object.keys(allTicketsByEmployee).length > 0 ? (
                Object.keys(allTicketsByEmployee)
                  .sort((a, b) => a.localeCompare(b)) // Sort names alphabetically
                  .map((employeeName) => (
                    <MenuItem
                      key={employeeName}
                      onClick={() => {
                        handleSearchResultClick(employeeName);
                        handleSearchClose();
                      }}
                      sx={{
                        fontSize: '1rem',
                        '&:hover': {
                          backgroundColor: '#b0b0b0',
                        },
                      }}
                    >
                      {employeeName}
                    </MenuItem>
                  ))
              ) : (
                <MenuItem disabled>No employees found</MenuItem>
              )}

          </Menu>

          <div className="sidebar-item-container">
            {/* side bar content */}
            {Object.entries(sideBarContent).map(([name, data]) => (
              <div key={name} className="sidebar-item">
                <h3 className="sidebar-title">{name}</h3>
                {data.ticketList.length === 0 ? (
                  <div className="no-tickets">No Ticket Available</div>
                ) : (
                  data.ticketList.map((ticket, index) => (
                    <div key={ticket.key} className="ticket-item">
                      {((ticketDetails[ticket.key]?.assignee || ticket.assignee) ||
                        (ticketDetails[ticket.key]?.developer || ticket.developer)) && (
                        <button
                          className="assignee-dev-button"
                          title={`${
                            (ticketDetails[ticket.key]?.assignee || ticket.assignee)
                              ? `Assignee: ${ticketDetails[ticket.key]?.assignee || ticket.assignee}`
                              : ""
                          }${
                            ((ticketDetails[ticket.key]?.assignee || ticket.assignee) &&
                            (ticketDetails[ticket.key]?.developer || ticket.developer))
                              ? "\n"
                              : ""
                          }${
                            (ticketDetails[ticket.key]?.developer || ticket.developer)
                              ? `Developer: ${ticketDetails[ticket.key]?.developer || ticket.developer}`
                              : ""
                          }`}
                        >
                          {(ticketDetails[ticket.key]?.assignee || ticket.assignee) &&
                            `A:${ticketDetails[ticket.key]?.assignee || ticket.assignee}`}
                          {((ticketDetails[ticket.key]?.assignee || ticket.assignee) &&
                            (ticketDetails[ticket.key]?.developer || ticket.developer)) &&
                            " | "}
                          {(ticketDetails[ticket.key]?.developer || ticket.developer) &&
                            `D:${ticketDetails[ticket.key]?.developer || ticket.developer}`}
                        </button>
                      )}

                      <div className="ticket-header">
                        <p className="ticket-id">
                          <strong>{index + 1}. Ticket-ID:</strong>{" "}
                          <a
                            href={`https://readyly.atlassian.net/browse/${ticket.key}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ticket-link"
                          >
                            {ticket.key}
                          </a>
                        </p>

                        <button
                          className="ticket-status"
                          style={{
                            backgroundColor:
                              statusColors[ticket.status]?.background ||
                              statusColors.default.background,
                            color:
                              statusColors[ticket.status]?.color ||
                              statusColors.default.color,
                          }}
                        >
                          {ticket.status}
                        </button>

                        {/* Priority Button */}
                        <button
                          style={{
                            padding: "5px 8px",
                            border: "none",
                            borderRadius: "5px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            cursor: "default",
                            backgroundColor:
                              ticket.priority === "Highest"
                                ? "#CD1317"
                                : ticket.priority === "High"
                                ? "#E9494A"
                                : ticket.priority === "Medium"
                                ? "#E97F33"
                                : ticket.priority === "Low"
                                ? "#2D8738"
                                : "#ddd",
                            color: "#fff",
                            minWidth: "60px",
                            textAlign: "center",
                          }}
                        >
                          {ticket.priority}
                        </button>

                        {/* Issue Type Icon */}
                        {(() => {
                            const type = ticket.issueType || ticket.issuetype || "Unknown";
                            const iconMap = {
                              Epic: "https://readyly.atlassian.net/images/icons/issuetypes/epic.svg",
                              Task: "https://readyly.atlassian.net/images/icons/issuetypes/task.svg",
                              "Sub-task": "https://readyly.atlassian.net/images/icons/issuetypes/subtask.svg",
                              Bug: "https://readyly.atlassian.net/images/icons/issuetypes/bug.svg",
                              Story: "https://readyly.atlassian.net/images/icons/issuetypes/story.svg",
                            };
                            const iconUrl = iconMap[type] || "https://readyly.atlassian.net/images/icons/issuetypes/default.svg";

                            return (
                              <img
                                src={iconUrl}
                                alt={type}
                                title={type}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginLeft: "5px",
                                  verticalAlign: "middle",
                                }}
                              />
                            );
                          })()}


                        {/* More Options Button */}
                        <IconButton
                          onClick={() => handleMoreClick(ticket.key)}
                          className="more-icon"
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      </div>

                      <p className="ticket-summary">
                        <strong>Summary:</strong> {ticket.summary}
                      </p>

                      {/* Expandable Details Section */}
                      {expandedTickets[ticket.key] &&
                        (loadingTickets[ticket.key] ? (
                          <div className="loading-spinner">Loading...</div>
                        ) : (
                          ticketDetails[ticket.key] && (
                            <div className="ticket-details">
                              {Object.entries(ticketDetails[ticket.key]).map(
                                ([key, value]) => {
                                  if (!value || value === "N/A") return null;

                                  if (
                                    key === "labels" &&
                                    Array.isArray(value) &&
                                    value.length === 0
                                  ) {
                                    return null;
                                  }

                                  if (key === "parent") {
                                    return (
                                      <p key={key}>
                                        <strong>
                                          {key.charAt(0).toUpperCase() +
                                            key.slice(1)}
                                          :
                                        </strong>{" "}
                                        <a
                                          href={`https://readyly.atlassian.net/browse/${value}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="parent-link"
                                        >
                                          {value}
                                        </a>
                                      </p>
                                    );
                                  }

                                  if (
                                    key === "labels" &&
                                    Array.isArray(value)
                                  ) {
                                    return (
                                      <p key={key}>
                                        <strong>
                                          {key.charAt(0).toUpperCase() +
                                            key.slice(1)}
                                          :
                                        </strong>{" "}
                                        {value.map((label, idx) => (
                                          <button
                                            key={idx}
                                            className="label-button"
                                          >
                                            {label}
                                          </button>
                                        ))}
                                      </p>
                                    );
                                  }

                                  return (
                                    <p key={key}>
                                      <strong>
                                        {key.charAt(0).toUpperCase() +
                                          key.slice(1)}
                                        :
                                      </strong>{" "}
                                      {value}
                                    </p>
                                  );
                                }
                              )}
                            </div>
                          )
                        ))}
                    </div>
                  ))
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SprintDashboard;
